// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__SjncR","productName":"Table_productName__1Qmph"};